import {Component, OnDestroy, OnInit} from '@angular/core';
import {ComponentItem} from '@Common/home/navbar/dynamic-core-components/component-item';
import {MenuNavComponent} from '@Common/home/navbar/components/menu-nav.component';
import {Subscription} from 'rxjs';
import {SubSink} from '@Common/core/utils/subsink';
import {Individu, IndividuService, PubSubService} from '@Common/core/services';
import {HelperIndividuService} from 'app/archivage/common/services/helper-individu/helper-individu.service';
import {Menu} from '@Common/home/models/menu.model';

@Component({
  selector: 'app-archivage-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Archivage';
  menu: Menu[] = [];
  showLoader = false;
  subSink = new SubSink();
  individu: Individu;

  subloading: Subscription;

  constructor(private individuService: IndividuService,
              private helperIndividuService: HelperIndividuService,
              private pubSubSvc: PubSubService) {
  }

  ngOnInit(): void {
    this.subloading = this.pubSubSvc.on('loading').subscribe((val) => {
      setTimeout(() => this.showLoader = val);
    });

    this.individuService.individu$.subscribe(individu => {
      this.helperIndividuService.individu = individu;
      this.fetchMenu();
    });
  }

  fetchMenu() {
    this.menu = [];
    this.menu.push({url: '/versement', titre: 'Versements', toolTip: 'Mes demandes de versements',
                    nav: true, icon: 'source'});
    this.menu.push({url: '/consultation', titre: 'Consultation d\'archives', toolTip: 'Mes demandes de consultations d\'archives',
      nav: true, icon: 'find_in_page'});
    if (this.helperIndividuService.isGestionnaire) {
      this.menu.push({url: '/gestion', titre: 'Gestion', nav: false, icon: 'apps'});
      this.menu.push({url: '/admin', titre: 'Administration', nav: false, icon: 'fa-cogs'});
    }
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  getComponents() {
    return [
      new ComponentItem(MenuNavComponent, this.menu)
    ];
  }
}
